// Campaigns page - intentionally unlisted but retained for potential future relaunch.

import React from 'react';
import { Link } from 'react-router';
import SEO from '../../seo/SEO';

type PastCampaign = {
  label: string;
  path?: string;
};

const pastCampaigns: PastCampaign[] = [
  { label: 'March Madness' },
  { label: 'New Year, New Games' },
  { label: 'Holiday Gift 2025' },
  { label: 'Black Friday Freeplay' },
  { label: 'Super 60' },
  { label: 'Never Pay May' },
  { label: 'OG-100' },
];

const Campaigns: React.FC = () => {
  return (
    <div className="min-h-svh bg-background pt-20 text-foreground sm:pt-24 md:pt-28 lg:pt-32">
      <SEO />
      <main className="mx-auto flex w-full max-w-screen-lg flex-col gap-10 px-4 pb-16 sm:px-6 md:px-8 lg:px-10">
        <nav
          aria-label="Breadcrumb"
          className="flex flex-wrap items-center gap-2 text-sm text-muted-foreground"
        >
          <Link to="/discover" className="hover:text-foreground">
            Discover
          </Link>
          <span aria-hidden="true">/</span>
          <span className="text-foreground">Campaigns</span>
        </nav>

        <header className="flex max-w-3xl flex-col gap-4">
          <h1 className="font-heading text-4xl leading-tight font-semibold tracking-tight md:text-5xl">
            Campaigns
          </h1>
          <p className="text-base leading-7 text-muted-foreground md:text-lg">
            Explore campaigns designed to bring streamers and players together
            through special events and community challenges.
          </p>
        </header>

        <section className="flex flex-col gap-4 border-t border-border pt-8">
          <h2 className="font-heading text-2xl leading-tight font-semibold tracking-tight md:text-3xl">
            Active Campaigns
          </h2>
          <p className="text-base leading-7 text-muted-foreground">
            No active campaigns are listed right now.
          </p>
        </section>

        <section className="flex flex-col gap-4 border-t border-border pt-8">
          <h2 className="font-heading text-2xl leading-tight font-semibold tracking-tight md:text-3xl">
            Past Campaigns
          </h2>
          <ul className="grid gap-3 text-base leading-7 sm:grid-cols-2">
            {pastCampaigns.map((campaign) => (
              <li key={campaign.label}>
                {campaign.path ? (
                  <Link to={campaign.path} className="hover:text-primary">
                    {campaign.label}
                  </Link>
                ) : (
                  <span>{campaign.label}</span>
                )}
              </li>
            ))}
          </ul>
        </section>
      </main>
    </div>
  );
};

export default Campaigns;
